var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from "react";
import { Link, useMutation, DynamicTable } from "@atlassiansox/microscopekit";
import Button from "@atlaskit/button"; // tslint:disable-line
import ShortcutIcon from "@atlaskit/icon/glyph/shortcut";
import uninstallMutation from "./uninstall-panel.mutation.graphql";
import installMutation from "./install-panel.mutation.graphql";
import { useIsServiceAdmin } from "../hooks";
import InlineMessage from "@atlaskit/inline-message"; // tslint:disable-line
export var UninstallButton = function (props) {
    var _a = useMutation(uninstallMutation), uninstallPanel = _a[0], loading = _a[1].loading;
    return (React.createElement(Button, { disabled: loading, isLoading: loading, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, uninstallPanel({
                                variables: {
                                    input: {
                                        panelName: props.panelName,
                                        serviceName: props.serviceName,
                                    },
                                },
                            })];
                    case 1:
                        _a.sent();
                        props.onSuccess();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        props.onFailure(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); }, appearance: "danger" }, "Uninstall"));
};
export var InstallButton = function (props) {
    var _a = useMutation(installMutation), installPanel = _a[0], loading = _a[1].loading;
    return (React.createElement(Button, { disabled: loading, isLoading: loading, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, installPanel({
                                variables: {
                                    input: {
                                        panelName: props.panelName,
                                        serviceName: props.serviceName,
                                    },
                                },
                            })];
                    case 1:
                        _a.sent();
                        props.onSuccess();
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        props.onFailure(e_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); }, appearance: "primary" }, "Install"));
};
export var PanelList = function (props) {
    var columns = [
        {
            key: "name",
            name: "Name",
            width: 15,
            content: function (val, row) {
                return row.isDeleted ? (React.createElement(InlineMessage, { type: "warning", secondaryText: val },
                    React.createElement("p", null,
                        React.createElement("strong", null, "This panel is deleted by its owner. It can no longer be used.")))) : (React.createElement(Link, { to: "/services/" + encodeURIComponent(props.serviceId) + "/panels/" + encodeURIComponent(val) }, val));
            },
        },
        { key: "description", name: "Description", width: 30 },
        { key: "owner", name: "Owner" },
        { key: "installedBy", name: "Installed By" },
        { key: "installedAt", name: "Installed At" },
        {
            key: "ssamContainerName",
            name: "SSAM",
            content: function (val) { return (React.createElement(Link, { to: "https://ssam.prod.atl-paas.net/access/containers/" + encodeURIComponent(val) },
                React.createElement(ShortcutIcon, { size: "small", label: "shortcut" }))); },
        },
    ];
    var isAdmin = useIsServiceAdmin(props.serviceId);
    var rows = props.panels.map(function (p) {
        var cols = columns.filter(function (c) { return p[c.key]; });
        var cells = cols.map(function (c) { return ({
            key: c,
            content: (c.content ? c.content(p[c.key], p) : p[c.key]),
        }); });
        if (isAdmin) {
            if (p["installedBy"]) {
                cells.push({
                    key: "uninstaller",
                    content: (React.createElement(UninstallButton, { panelName: p.name, serviceName: props.serviceId, onSuccess: function () {
                            var _a;
                            (_a = props.onUninstallSuccess) === null || _a === void 0 ? void 0 : _a.call(props, p.name);
                        }, onFailure: function (e) {
                            var _a;
                            (_a = props.onUninstallFailure) === null || _a === void 0 ? void 0 : _a.call(props, p.name, e);
                        } })),
                });
            }
            else {
                cells.push({
                    key: "installer",
                    content: (React.createElement(InstallButton, { panelName: p.name, serviceName: props.serviceId, onSuccess: function () {
                            var _a;
                            (_a = props.onInstallSuccess) === null || _a === void 0 ? void 0 : _a.call(props, p);
                        }, onFailure: function (e) {
                            var _a;
                            (_a = props.onInstallFailure) === null || _a === void 0 ? void 0 : _a.call(props, p.name, e);
                        } })),
                });
            }
        }
        return {
            cells: cells,
        };
    });
    return props.panels.length ? (React.createElement(DynamicTable, { head: {
            cells: __spreadArrays(columns
                .filter(function (c) { return props.panels[0][c.key]; })
                .map(function (c) { return (__assign(__assign({}, c), { content: c.name })); }), [
                { key: "button", content: "" },
            ]),
        }, rows: rows })) : null;
};
